import React, { ReactElement } from 'react';
import { NavigationButtons } from '../../shared/NavigationButtons';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../store/store';
import { createSelectOptionSchema } from '../../schema';
import { FormikFormField } from '@frontman/rt-protections-ui';
import { Formik, Form } from 'formik';
import Select from '@ramsey-design-system/select';
import {
  CoverageCheckupState,
  goToNextStep,
  updateCoverageCheckupState,
} from '../../../store/step';
import { CardPadding, GrayCard, GrayCardHeader } from '../../shared/CardStyles';
import { CardHeader } from '../../shared/CardStyles/CardHeader';
import { useFormInteractionTracking } from '../../../hooks/useFormInteractionTracking';
import { incomeRange } from '../../../utils/shared';

function IncomeStep(): ReactElement {
  const dispatch = useDispatch();
  const { yearlyHouseholdIncome: yearlyHouseholdIncome } = useSelector(
    (state: RootState) => state.steps
  );

  const formRef = useFormInteractionTracking('income');

  function onSubmit(values: Partial<CoverageCheckupState>): void {
    dispatch(updateCoverageCheckupState(values));
    dispatch(goToNextStep());
  }
  return (
    <>
      <GrayCard>
        <GrayCardHeader
          header="Now, your finances. Ballpark figures are fine!"
          subHeader="No need to look anything up here. Give your best guess!"
        />
      </GrayCard>

      <CardPadding>
        <CardHeader
          header="What's your yearly income?"
          subHeader="This affects your level of need for two types of coverage."
        />
        <Formik
          initialValues={{ yearlyHouseholdIncome }}
          onSubmit={onSubmit}
          validationSchema={createSelectOptionSchema('yearlyHouseholdIncome')}
        >
          <Form className="rds-Select-sm" ref={formRef}>
            <FormikFormField<CoverageCheckupState>
              id="yearlyHouseholdIncome"
              name="yearlyHouseholdIncome"
              className="u-spacingBlockMd"
              inputComponent={Select}
              rdsAttributes={{ length: 'lg' }}
            >
              <option value="">Select an Option</option>
              {incomeRange.map((option, index) => (
                <option key={index} value={option}>
                  {option}
                </option>
              ))}
            </FormikFormField>
            <NavigationButtons />
          </Form>
        </Formik>
      </CardPadding>
    </>
  );
}

export { IncomeStep };
